import { LocalizationData, LocalizationPath } from '../../../../../../../core/src'
import { LocalizationService } from '../../../../../../core/src'
import { IAlertModalProps } from '../interface'

export class ErrorModalFactory {
  /**
   * Error modal props for when uploaded image type is incorrect
   */
  static ImageTypeError(localization: LocalizationData): IAlertModalProps {
    return {
      header: LocalizationService.t<string>(localization, LocalizationPath.ImageUploaderErrorImageType),
      padding: 'ph-40'
    }
  }
  /**
   * Error modal props for when uploaded image type is incorrect
   */
  static ImageSizeError(localization: LocalizationData): IAlertModalProps {
    return {
      header: LocalizationService.t<string>(localization, LocalizationPath.ImageUploaderErrorImageSize),
      padding: 'ph-50'
    }
  }
  /**
   * Error modal props for when uploaded image type is incorrect
   */
  static UploadFailedError(localization: LocalizationData): IAlertModalProps {
    return {
      header: LocalizationService.t<string>(localization, LocalizationPath.ImageUploaderErrorUploadFailed),
      padding: 'ph-40'
    }
  }
  /**
   * Default Error props for when an item cannot be deleted
   */
  static ItemCannotBeDeletedError(): IAlertModalProps {
    return {
      header: '削除できません',
      padding: 'ph-40'
    }
  }
  /**
   * Default Error props for when an item cannot be deleted
   */
  static AlertTitle(fieldName: string): IAlertModalProps {
    return {
      header: fieldName,
      padding: 'ph-40'
    }
  }
  /**
   * Error modal props for when uploaded image type is incorrect
   */
  static ApplicationSaveError(): IAlertModalProps {
    return {
      header: 'Submission Failed',
      padding: 'ph-10'
    }
  }
  /**
   * Error modal props for generic error header
   */
  static AnErrorHasOccured(): IAlertModalProps {
    return {
      header: 'エラーが発生しました',
      padding: 'ph-40'
    }
  }
}
